// src/config/api.ts

/**
 * API Configuration
 * 
 * This file contains configuration for API endpoints and related settings.
 * Replace placeholder values with your actual API configuration before deployment.
 */

import { getApiBaseUrl } from '../utils/environment';

export const apiConfig = {
  // Base URL for API requests
  baseUrl: getApiBaseUrl(),
  
  // Default request timeout in milliseconds
  timeout: 30000,
  
  // Default headers to include with all requests
  defaultHeaders: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  
  // Retry configuration for failed requests
  retry: {
    maxRetries: 3,
    initialDelay: 1000,
    backoffFactor: 2,
    maxDelay: 10000,
  },
  
  // Cache configuration
  cache: {
    enabled: true,
    maxAge: 300000, // 5 minutes in milliseconds
    excludedRoutes: [
      '/auth/token',
      '/auth/refresh',
      '/state/update',
      '/events',
    ],
  },
};

/**
 * API Routes
 * These should match the endpoints exposed by your backend API
 */
export const apiRoutes = {
  // Authentication
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    token: '/auth/token',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
  },
  
  // User
  user: {
    profile: '/user/profile',
    settings: '/user/settings',
    avatar: '/user/avatar',
  },
  
  // Campaigns
  campaigns: {
    list: '/campaigns',
    create: '/campaigns',
    details: (id: string) => `/campaigns/${id}`,
    update: (id: string) => `/campaigns/${id}`,
    delete: (id: string) => `/campaigns/${id}`,
    join: (id: string) => `/campaigns/${id}/join`,
    leave: (id: string) => `/campaigns/${id}/leave`,
  },
  
  // Sessions
  sessions: {
    list: '/sessions',
    create: '/sessions',
    details: (id: string) => `/sessions/${id}`,
    update: (id: string) => `/sessions/${id}`,
    delete: (id: string) => `/sessions/${id}`,
    start: (id: string) => `/sessions/${id}/start`,
    end: (id: string) => `/sessions/${id}/end`,
  },
  
  // Characters
  characters: {
    list: '/characters',
    create: '/characters',
    details: (id: string) => `/characters/${id}`,
    update: (id: string) => `/characters/${id}`,
    delete: (id: string) => `/characters/${id}`,
  },
  
  // Game
  game: {
    state: (sessionId: string) => `/game/${sessionId}/state`,
    action: (sessionId: string) => `/game/${sessionId}/action`,
    chat: (sessionId: string) => `/game/${sessionId}/chat`,
  },
};

export default apiConfig;
